<div id="device-configuration-upload-component" class="component-inner-wrapper onboarding-component-class"
>
  <main class="main-content">
    <div class="container">
      <div class="breadcrumb">
        <span>OTA</span>
        <span>></span>
        <span class="ele_link" [routerLink]="['/ota/device-configuration-upload']" >Update Device Configuration</span>
    </div>
      <h1 class="page-title mb-4">Update Device Configuration</h1>
      <p class="paraStyle">
        Specify the configuration you would like to apply, then select the
        customer and group for the devices you are updating.
      </p>
      <div class="content-wrapper">
        <div class="upload-section container-sections">
          <form id="uploadForm">
            <div class="form-horizontal">
              <!-- <div class="form-group">
                <label class="form-label" style="position: relative;"
                  >Config Version<span class="text-danger">*</span>
                  </label>
                <input type="number"
                  (keyup)="getConfigVersion($event)"
                  name="config" placeholder="Numeric input only"
                  [(ngModel)]="config" class="config no-spinner" min="0" step="1"
                  oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                />
              </div> -->

              <!-- CUSTOMER FIELD -->
                <div class="form-group">
                  <label class="form-label">
                    Customer <span class="text-danger">*</span>
                  </label>

                  <div class="input-wrapper">
                    <input
                      type="text"
                      matInput
                      [formControl]="customerControl"
                      [matAutocomplete]="autoCustomer"
                      [placeholder]="customerDropdownSelectLabel"
                    />
                    <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
                  </div>

                  <mat-autocomplete
                    #autoCustomer="matAutocomplete"
                    (optionSelected)="onCustomerChange($event)"
                    [displayWith]="displayFn"
                  >
                    @for (customer of filteredCustomers | async; track customer.id) {
                      <mat-option [value]="customer">{{ customer.customerName }}</mat-option>
                    }
                  </mat-autocomplete>
                </div>

                <!-- GROUP FIELD -->
                <div class="form-group">
                  <label class="form-label">
                    Group <span class="text-danger">*</span>
                  </label>

                  <div class="input-wrapper">
                    <input
                      type="text"
                      matInput
                      [formControl]="groupControl"
                      [matAutocomplete]="autoGroup"
                      [placeholder]="groupDropdownEmptyLabel"
                    />
                    <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
                  </div>

                  <mat-autocomplete
                    #autoGroup="matAutocomplete"
                    (optionSelected)="onGroupChange($event)"
                    [displayWith]="displayGroupFn"
                  >
                    @if (groupsLoaded && groups.length === 0 && selectedCustomer) {
                      <mat-option disabled>{{ groupDropdownEmptyLabel }}</mat-option>
                    }
                    @for (group of filteredGroups | async; track group.id) {
                      <mat-option [value]="group">{{ group.groupName }}</mat-option>
                    }
                  </mat-autocomplete>
                </div>

            </div>

            <div
              #uploadArea
              class="upload-area"
              (click)="triggerFileInput()"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave()"
              (drop)="onFileDrop($event)"
              [style.borderColor]="borderColor"
              [class.disabled]="!selectedCustomer || !selectedGroup"
              [class.pointer-events-none]="
                !selectedCustomer || !selectedGroup
              "
            >
              <span class="material-symbols-outlined upload-icon">
                cloud_download
              </span>
              <p style="font-size: small; margin-bottom: 0; font-weight: 500">
                Drag & Drop file here
              </p>
              <p style="font-size: small; font-weight: 500">or</p>
              <button type="button" class="btn btn-confirm">Choose file</button>
              <p class="upload-text">{{ uploadText }}</p>
            </div>
            <input
              #fileInput
              type="file"
              class="file-input"
              (change)="onFileInputChange($event)"
            />
          </form>
        </div>
      </div>
      <!-- <button
        *ngIf="showUploadButton"
        type="button"
        class="btn btn-confirm"
        (click)="uploadFile()"
        [disabled]="
          !selectedCustomer || !selectedGroup || !config || !isFileUploaded
        "
      >
        Upload file
      </button> -->
    </div>
  </main>
</div>
